import { useQueryClient } from '@tanstack/react-query';
import keys from './keys';
import userKeys from '../user/keys';
import useApiMutation from '../useApiMutation';

const useSetEpisode = () => {
  const queryClient = useQueryClient();
  const mutation = useApiMutation({
    getRequestUrl: ({ showId, episodeId }) => `/shows/${showId}/episodes/${episodeId}`,
    method: 'PATCH',
    onSuccess: (newEpisodeData) => {
      queryClient.setQueryData(
        keys(newEpisodeData.show).episode(newEpisodeData._id),
        newEpisodeData
      );
      queryClient.invalidateQueries(keys(newEpisodeData.show).episodes);
      queryClient.invalidateQueries(userKeys.me);
    },
  });

  return {
    setEpisode: mutation.mutate,
    setEpisodeAsync: mutation.mutateAsync,
    isSetEpisodeLoading: mutation.isLoading,
    isSetEpisodeError: mutation.isError,
    isSetEpisodeSuccess: mutation.isSuccess,
    ...mutation,
  };
};

export default useSetEpisode;
